module.exports = vendor_redux_lib;